export class AgreementWithCredits {
    'id';
    'marketplaceAccountId';
    'startTime';
    'endTime';
    'originalCredits';
    'remainingCredits';
    'cloudProvider';
    'type';
    'marketplaceAgreementId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "marketplaceAccountId",
            "baseName": "marketplaceAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "originalCredits",
            "baseName": "originalCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "remainingCredits",
            "baseName": "remainingCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "AgreementWithCreditsTypeEnum",
            "format": ""
        },
        {
            "name": "marketplaceAgreementId",
            "baseName": "marketplaceAgreementId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AgreementWithCredits.attributeTypeMap;
    }
    constructor() {
    }
}
export var AgreementWithCreditsTypeEnum;
(function (AgreementWithCreditsTypeEnum) {
    AgreementWithCreditsTypeEnum["Agreement"] = "AGREEMENT";
    AgreementWithCreditsTypeEnum["Refund"] = "REFUND";
})(AgreementWithCreditsTypeEnum || (AgreementWithCreditsTypeEnum = {}));
